import { ChangeDetectorRef, Component, DestroyRef, ElementRef, EventEmitter, inject, Injector, Input, Output, runInInjectionContext, SimpleChanges, ViewChild } from '@angular/core';
import { MatAccordion, MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { ParaComponent } from "../para/para.component";
import { ListComponent } from "../list/list.component";
import { CommonModule } from '@angular/common';
import { DataItem, Group } from '../../Model/model';
import { TableComponent } from '../table/table.component';
import { AccordionCoordinatorService } from '../../Services/Accordion/accordion-coordinator.service';
import { EventEmitterService } from '../../Services/Common/event-emitter.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ResourcesListComponent } from "../resources-list/resources-list.component";
import { EncryptionService } from '../../Services/encryption';

@Component({
  selector: 'app-accordion',
  imports: [MatExpansionModule, TableComponent, MatAccordion, ParaComponent, ListComponent, CommonModule, ResourcesListComponent],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss'
})
export class AccordionComponent {

  @Input() panelHeader?: string;
  @Input() blocks?: DataItem[];
  @Input() id!: number;
  @Input() selectedId: number | null = null;
  @Output() openedEvent = new EventEmitter<number>();
  @Input() usePortalBaseForRelativeLinks = false;
  @Input() noPagination = false;

  sortedBlocks: any[] = [];
  @ViewChild(MatExpansionPanel, { static: true }) panel!: MatExpansionPanel;
  expandedHeaderTitle: string | null = null
  expanded = false
  private readonly injector = inject(Injector);
  private encryptionService = inject(EncryptionService);
  private elementRef = inject(ElementRef);


  constructor(private bus: EventEmitterService, private cdr: ChangeDetectorRef, private coord: AccordionCoordinatorService) {

    bus.on()
      .pipe(takeUntilDestroyed())
      .subscribe(ev => {
        if (ev) {
          try {
            if (typeof window !== 'undefined' && window.localStorage) {
              try {
                const encrypted = this.encryptionService.encrypt(ev);
                localStorage.setItem('data', encrypted);
              } catch (err) {
                // fallback
                localStorage.setItem('data', ev);
              }
            }
          } catch (err) {
            // ignore storage errors
          }
          this.cdr.markForCheck();
        }
      })



  }


  ngOnInit() {
    this.blocks = Array.isArray(this.blocks) ? this.blocks : [];
    this.sortedBlocks = [...this.blocks].sort((a, b) => (Number(a.position || 0)) - (Number(b.position || 0)));
    // this.coord.onOpened()
    //   .pipe(takeUntilDestroyed())
    //   .subscribe(title => {
    //     const mine = this.slug(this.blocks![0].header ?? '');
    //     const isMe = !title && this.slug(title) === mine
    //     // this.expanded = this.slug(title) === this.slug(this.blocks![0].header)

    //     if (isMe) this.panel.open(); else this.panel.close();
    //     this.cdr.markForCheck();
    //   })


    runInInjectionContext(this.injector, () => {
      this.coord.onOpened()
        .pipe(takeUntilDestroyed())
        .subscribe(title => {
          const mine = this.slug(this.blocks![0].header ?? '');
          const isMe = title && this.slug(title) === mine;

          if (isMe) this.panel.open(); else this.panel.close();
          this.cdr.markForCheck();
        });
    });


  }



  ngAfterViewInit() {
    /* The `// this.tryEval();` line is a commented-out call to the `tryEval()` method in the
    `AccordionComponent` class. This method is responsible for checking if the
    `expandedHeaderTitle` matches the header of the first block in the `blocks` array and setting
    the `expanded` property accordingly. */
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        const raw = localStorage.getItem('data');
        if (raw) {
          try {
            const decrypted = this.encryptionService.decrypt(raw);
            this.expandedHeaderTitle = typeof decrypted === 'string' ? decrypted : JSON.stringify(decrypted);
          } catch (err) {
            this.expandedHeaderTitle = raw;
          }
        }
      }
      this.tryEval();
    } catch (err) {
      // ignore
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    if ('selectedId' in changes) {
      this.expanded = this.selectedId === this.id
    }
  }
  getResourcesList(d: any): string[][] {
    if (d.titles && d.urls && Array.isArray(d.titles) && Array.isArray(d.urls)) {
      return [d.titles, d.urls];
    }
    return [[], []];
  }

  tryEval() {
    if (!this.blocks || !this.expandedHeaderTitle) return;
    // this.expanded = this.slug(this.expandedHeaderTitle) === this.slug(this.blocks![0].header);
    this.cdr.markForCheck();
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('data');
    }
  }

  slug(s: string) {
    return String(s || ""
      .trim()
      .toLowerCase()
      .replace(/[\s_]+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
    )
  }

  isMatch(sel: string, header?: string) {
    if (!sel || !header) return false;
    return this.slug(sel) === this.slug(header)
  }


  onOpened() {
    if (this.blocks![0].header) {

      if (this.id !== this.selectedId) this.openedEvent.emit(this.id);
      this.coord.announceOpen(this.blocks![0].header);
    }


  }


}
